module.exports = __webpack_public_path__ + "static/media/augendusche.aca515cb.jpg";